import { i18n } from 'core/i18n';

const errorCodeMaping = (response = {}, errType = '') => {
	const { status = '', data = {} } = response,
		{ code = '', message = '' } = data;
	
	let error = {
		errorMessage: '',
		errorRedirect: ''
	};

	if (status) {
		switch (status) { 
			case 504: // 連線失敗
				error.errorMessage = i18n('error_message_ServerError') + ' (code:' + status + ')';
				break;
			case 401: // 登入逾時
				error.errorMessage = i18n('error_session_timeout') + ' (code:' + status + ')';
				error.errorRedirect = 'login'
				break;
			default:
				if (data) {
					error.errorMessage = message ? message : i18n('error_message_tryAgain') + ' (code:' + code + ')'
				} else {
					error.errorMessage = i18n('error_message_tryAgain') + ' (code:' + status + ')'
				}
				break;
		}
	} else { 
		error.errorMessage = i18n('error_message_tryAgain');
	}
	return error;
};

export default {
	errorCodeMaping
};
